<svg
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={$$props.class}
>
  <path
    d="M13.5 13.5V14.25H14.25V13.5H13.5ZM2.5 13.5H1.75V14.25H2.5V13.5ZM2.5 2.5V1.75H1.75V2.5H2.5ZM7.5 3.25H8.25V1.75H7.5V3.25ZM14.25 8.5V7.75H12.75V8.5H14.25ZM8.5 5.5L7.96967 4.96967L7.75 5.18934V5.5H8.5ZM8.5 7.5H7.75V8.25H8.5V7.5ZM10.5 7.5V8.25H10.8107L11.0303 8.03033L10.5 7.5ZM12.5 1.5L13.0303 0.96967L12.5 0.43934L11.9697 0.96967L12.5 1.5ZM14.5 3.5L15.0303 4.03033L15.5607 3.5L15.0303 2.96967L14.5 3.5ZM13.5 12.75H2.5V14.25H13.5V12.75ZM3.25 13.5V2.5H1.75V13.5H3.25ZM2.5 3.25H7.5V1.75H2.5V3.25ZM12.75 8.5V13.5H14.25V8.5H12.75ZM7.75 5.5V7.5H9.25V5.5H7.75ZM8.5 8.25H10.5V6.75H8.5V8.25ZM9.03033 6.03033L13.0303 2.03033L11.9697 0.96967L7.96967 4.96967L9.03033 6.03033ZM11.9697 2.03033L13.9697 4.03033L15.0303 2.96967L13.0303 0.96967L11.9697 2.03033ZM13.9697 2.96967L9.96967 6.96967L11.0303 8.03033L15.0303 4.03033L13.9697 2.96967Z"
    fill="currentColor"
  />
</svg>
